import { render, staticRenderFns } from "./iconGroup.vue?vue&type=template&id=1e55ff52&scoped=true"
import script from "./iconGroup.vue?vue&type=script&lang=js"
export * from "./iconGroup.vue?vue&type=script&lang=js"
import style0 from "./iconGroup.vue?vue&type=style&index=0&id=1e55ff52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e55ff52",
  null
  
)

export default component.exports